import React from 'react';
import { QUIZ_GRADIENT_COLORS } from '@/features/hair-quiz/constants';
import { MeshGradientBackground } from '@/features/hair-quiz/components/mesh-gradient-background';
import { cn } from '@/lib/utils';
import { ClubHeader } from './club-header';
import { ClubFooter } from './club-footer';

interface Props {
  children: React.ReactNode;
  hasHeader?: boolean;
  hasFooter?: boolean;
  useMeshGradientBackground?: boolean;
  mainWidthMode?: 'default' | 'full';
}

export function ClubLayout({
  children,
  hasHeader = true,
  hasFooter = true,
  useMeshGradientBackground = false,
  mainWidthMode = 'default',
}: Props) {
  return (
    <div className="relative min-h-screen bg-white">
      {useMeshGradientBackground && (
        <>
          <MeshGradientBackground
            colors={QUIZ_GRADIENT_COLORS}
            className="pointer-events-none fixed inset-0 z-0"
            speed={0.5}
          />
          <div
            aria-hidden="true"
            className="pointer-events-none fixed inset-0 z-[1] bg-[rgba(254,254,254,0.4)]"
          />
        </>
      )}
      <div className="relative z-10">
        {hasHeader && <ClubHeader />}
        <main
          className={cn(
            'mx-auto w-full',
            mainWidthMode === 'full'
              ? 'max-w-none'
              : 'max-w-xl md:max-w-[432px]',
          )}
        >
          {children}
        </main>
        {hasFooter && <ClubFooter />}
      </div>
    </div>
  );
}

export default ClubLayout;
